import axios from 'axios'
import * as types from "../mutation-types";

// state
export const state = {
    data: null,
    data_loaded: true,
    date : {
        from: null,
        to : null
    },

    month: {
        0: "Jan",
        1: "Feb",
        2: "Mar",
        3: "Apr",
        4: "May",
        5: "Jun",
        6: "Jul",
        7: "Aug",
        8: "Sep",
        9: "Oct",
        10: "Nov",
        11: "Dec"
    },
}

// getters
export const getters = {}

// mutations
export const mutations = {
    [types.LOAD_INVOICES](state)
    {
        state.data_loaded = false;
    },

    [types.GET_INVOICES](state, {invoices, date})
    {
        state.data = invoices;
        state.data_loaded = true;
        state.date = date;
    },

    [types.GET_DATE](state)
    {
        if (state.date.from === null && state.date.to === null)
        {
            let current_date = new Date();
            let date_from = new Date(current_date.getFullYear(), current_date.getMonth(), 1);
            let date_to = new Date(current_date.getFullYear(), current_date.getMonth() + 1, 0);
            date_from = date_from.getDate() + " " + state.month[date_from.getMonth()] + " " + date_from.getFullYear();
            date_to = date_to.getDate() + " " + state.month[date_to.getMonth()] + " " + date_to.getFullYear();

            state.date.from = date_from;
            state.date.to = date_to;
        }
    },

    [types.GET_INVOICES_FAILURE](state)
    {
        state.invoices = null;
        state.data_loaded = false;
    },
}

// actions
export const actions = {

    async getInvoices({commit})
    {
        try
        {
            let {data} = await axios.post('/api/invoices');
            data.forEach(function (element) {
                element.money = JSON.parse(element['seller']).currency;
                element.date = new Date(element['ts'] * 1000);
            });
            commit(types.GET_INVOICES, {invoices: data})
        } catch (e)
        {
            commit(types.GET_INVOICES_FAILURE)
        }
    },

    async getInvoicesForDate({commit}, date)
    {
        try
        {
            commit(types.LOAD_INVOICES);
            let {data} = await axios.post('/api/invoicesDate', {
                DateFrom: date.from,
                DateTo: date.to
            });
            data.forEach(function (element) {
                element.money = JSON.parse(element['seller']).currency;
                element.date = new Date(element['ts'] * 1000);
            });

            commit(types.GET_INVOICES, {invoices: data, date : date})

        } catch (e)
        {
            commit(types.GET_INVOICES_FAILURE)
        }
    },

    async getDates({commit})
    {
        commit(types.GET_DATE)
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/invoices.js